import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=1f29d17d&scoped=true&"
import script from "./bottom.vue?vue&type=script&lang=ts&"
export * from "./bottom.vue?vue&type=script&lang=ts&"
import style0 from "./bottom.vue?vue&type=style&index=0&id=1f29d17d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29d17d",
  null
  
)

export default component.exports